module.exports = __webpack_public_path__ + "img/a4.3157a8b4.png";